import React from 'react'
import { Popup } from 'semantic-ui-react'
import { currencyFormat } from '../../../../utils/currencyFormat'

type Props = {
  widgetValues: { paid: number, remaining: number, total: number }
  total_budget: number
  popup?: boolean
  height?: string
}

const ServiceProviderDCProgress = (props: Props): JSX.Element => {

  const { widgetValues, total_budget, popup, height } = props
  const popupContent = () => {
    return (
      <div>
        <div style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Invoice Completion</div>
        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#08D6A1', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Paid</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF', fontWeight: 500 }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.paid)[0]} {currencyFormat(widgetValues.paid).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.paid).split(',')[1]}</p>
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#F3F3F3', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Remaining</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.remaining)[0]} {currencyFormat(widgetValues.remaining).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.remaining).split(',')[1]}</p>
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#747678', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Total</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.total)[0]} {currencyFormat(widgetValues.total).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.total).split(',')[1]}</p>
          </div>
        </div>
      </div>
    )
  }

  const subBarValues = () => {
    return (
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
        {/* Paid */}
        <div style={{ alignItems: 'flex-start', minWidth: '10%', width: `${(widgetValues.paid / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#08D6A1', margin: 0 }}>{currencyFormat(widgetValues.paid)[0]} {currencyFormat(widgetValues.paid).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.paid).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'left', fontWeight: 600, marginTop: '0.3rem' }}>Paid</div>
        </div>
        {/* End */}
        {/* Remaining */}
        <div style={{ alignItems: 'flex-end', minWidth: '10%', width: `${(widgetValues.remaining / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#747678', margin: 0 }}>{currencyFormat(widgetValues.remaining)[0]} {currencyFormat(widgetValues.remaining).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.remaining).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'right', fontWeight: 600, marginTop: '0.3rem' }}>Remaining</div>
        </div>
        {/* End */}
      </div>
    )
  }

  const renderBar = () => {
    const valuePaid = (widgetValues.paid / widgetValues.total) * 100
    const valueRemaining = (widgetValues.remaining / widgetValues.total) * 100
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ borderRadius: '7px', width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: widgetValues.remaining === 0 ? '#F3F3F3' : '#747678' }}>
          <div style={{ borderTopLeftRadius: '7px', borderBottomLeftRadius: '7px', borderTopRightRadius: valuePaid >= 100 ? '7px' : '0px', borderBottomRightRadius: valuePaid >= 100 ? '7px' : '0px', backgroundColor: '#08D6A1', width: `${valuePaid}%`, height: height ?? '1rem' }}></div>
          <div style={{ borderTopLeftRadius: widgetValues.remaining === 0 || widgetValues.paid > 0 ? '0px' : '7px', borderBottomLeftRadius: widgetValues.remaining === 0 || widgetValues.paid > 0 ? '0px' : '7px', borderTopRightRadius: '7px', borderBottomRightRadius: '7px', backgroundColor: '#F3F3F3', width: `${valueRemaining}%`, height: height ?? '1rem' }}></div>
        </div>
        {!popup && popup !== undefined ? subBarValues() : null}
      </div>
    )
  }


  if (!popup && popup !== undefined) {
    return renderBar()
  }
  const valuePaid = (widgetValues.paid / widgetValues.total) * 100
  const valueRemaining = (widgetValues.remaining / widgetValues.total) * 100
  return (
    <Popup
      on='hover'
      hoverable
      trigger={
        <div style={{ borderRadius: '7px', width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: widgetValues.remaining === 0 ? '#F3F3F3' : '#747678' }}>
          <div style={{
            borderTopLeftRadius: '7px',
            borderBottomLeftRadius: '7px',
            borderTopRightRadius: valuePaid >= 100 ? '7px' : '0px',
            borderBottomRightRadius: valuePaid >= 100 ? '7px' : '0px',
            backgroundColor: '#08D6A1',
            width: `${valuePaid}%`,
            height: height ?? '1rem'
          }}>
          </div>
          <div
            style={{
              borderTopLeftRadius: widgetValues.remaining === 0 || widgetValues.paid > 0 ? '0px' : '7px',
              borderBottomLeftRadius: widgetValues.remaining === 0 || widgetValues.paid > 0 ? '0px' : '7px',
              borderTopRightRadius: '7px',
              borderBottomRightRadius: '7px',
              backgroundColor: '#F3F3F3',
              width: `${valueRemaining}%`, height: height ?? '1rem'
            }} />
        </div>
      }
      style={{ backgroundColor: '#4E5579', color: '#FFF', borderRadius: '8px', minWidth: '14rem', minHeight: '10rem' }}
      className='popup-info'
      content={popupContent()}
      position='bottom center'
      offset={[-100, 0]}
    />
  )
}

export default ServiceProviderDCProgress
